import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight, Sparkles } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { Button } from "@/components/ui/button";
import { appConfig } from "@inginuiti/enums";
import { ResourcesOverview } from "@/features/resources/modules/overview/overview";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/resources/")({
  loader: () => ({ crumb: m.better_studio_nav_resources() }),
  component: ResourcesOverviewPage,
});

function ResourcesOverviewPage() {
  return (
    <PageShell
      icon={Sparkles}
      badge={m.better_studio_resources_badge({ name: appConfig.name })}
      title={
        <>
          {m.better_studio_resources_title_lead()}{" "}
          <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-primary/50">
            {m.better_studio_resources_title_highlight()}
          </span>
        </>
      }
      description={m.better_studio_resources_description()}
      demo
      actions={
        <Button asChild variant="outline" size="sm" className="border-border/60">
          <Link to="/resources/docs">
            {m.better_studio_cta_read_docs()}
            <ArrowRight className="size-3.5" />
          </Link>
        </Button>
      }
    >
      <ResourcesOverview />
    </PageShell>
  );
}
